import { render } from "./TheFooter.vue?vue&type=template&id=0afe681a&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=0afe681a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\v-tax-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afe681a"]])

export default __exports__